// extracted by mini-css-extract-plugin
export var compactFilters = "_ef-4";
export var detailImage = "_ef-1";
export var dropdownContainer = "_ef-2";
export var imageContainer = "_ef-0";
export var selectedCard = "_ef-3";